import { useTranslation } from 'react-i18next';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Card,
    CardContent,
    Divider,
    Stack,
    Typography,
} from '@mui/material';
import { deviationToSwingString } from '@travelity/api/services';
import type { PackageSidebarItemsProps } from './types';

export const PackageSchedule = ({ product }: PackageSidebarItemsProps) => {
    const { t } = useTranslation('product');

    return (
        <Accordion disableGutters>
            <AccordionSummary>{t('Schedules')}</AccordionSummary>
            <AccordionDetails>
                {product.products.map(p => (
                    <Card
                        key={p.day_index}
                        variant="outlined"
                        sx={{
                            overflow: 'hidden',
                            mb: 2,
                        }}
                    >
                        <CardContent sx={{ p: 2.5, background: '#F8F9FA' }}>
                            <Stack spacing={1.5}>
                                <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: 700 }}
                                >
                                    Day {p.offset_days + 1}
                                </Typography>
                                <Divider />
                                <Stack spacing={1.25}>
                                    {p.items.map(({ id, ref, start_time }) => (
                                        <Box
                                            key={id}
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: '1fr auto',
                                                gap: 2,
                                                alignItems: 'start',
                                            }}
                                        >
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                sx={{ minWidth: 0 }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontWeight: 500,
                                                        overflow: 'hidden',
                                                        textOverflow:
                                                            'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        minWidth: 0,
                                                    }}
                                                    title={ref.name}
                                                >
                                                    {ref.name}
                                                </Typography>
                                            </Stack>

                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    fontWeight: 700,
                                                    textAlign: 'right',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {deviationToSwingString(
                                                    start_time
                                                )}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};
